const monicaPlayerSpritesheet = {
  "name": "monicaPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 4,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/monicaPlayerSpritesheet.png",
  "sprites": {
    "monicaPlayerHead": [0],
    "monicaPlayerBody": [1]
  }
}
export default monicaPlayerSpritesheet;
